import React, {useState, useEffect} from 'react'
import '../styles/_index.scss'
import FormShippingRule from "./templates/FormShippingRule"
import {Link} from "react-router-dom"
import {message} from "antd"
import {updateShippingRule, getDetailShippingRule, listPlatform} from "../../../services/api/apiPacking"
import getHistory from "../../../getHistory"
import ShippingHistory from "./ShippingHistory"

function EditShippingRule(props) {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [shippingRules, setShippingRules] = useState({})
    const [platforms, setPlatforms] = useState([])

    async function upShippingRule(data) {
        setLoading(true)
        setError('')

        try {
            const {match} = props
            const {shipping_rule_id} = match.params

            const {data: response} = await updateShippingRule(shipping_rule_id, data)

            const {success, message: error} = response

            if (!success) {
                setLoading(false)

                return message.error(error)
            }

            setLoading(false)

            const history = getHistory()
            history.push(`/shipping-rule`)

            message.success('Update rule successfully!')
        } catch (e) {
            setLoading(false)

            message.error(e.message)
        }
    }

    async function getShippingRule() {
        try {
            const {match} = props
            const {shipping_rule_id} = match.params

            const {data: response} = await getDetailShippingRule(shipping_rule_id)

            const {success, message: error, data} = response

            if (!success) {
                setLoading(false)

                return message.error(error)
            }

            setLoading(false)
            setShippingRules(data)
        } catch (e) {
            setLoading(false)

            message.error(e.message)
        }
    }

    async function getPlatform() {
        try {
            const {data: response} = await listPlatform()

            const {success, message: error, data} = response

            if (!success) {
                return message.error(error)
            }

            setPlatforms(data)
        } catch (e) {
            return message.error(e.message)
        }
    }

    useEffect(() => {
        getPlatform()
        getShippingRule()
        // eslint-disable-next-line
    }, [])

    const {match} = props
    const {shipping_rule_id} = match.params

    return (
        <div className="NewShippingRule">
            <div className="BackWrapper">
                <Link to='/shipping-rule'><i className='fa fa-chevron-left'/> Setting shipping rule</Link>
            </div>

            <div className="TitlePage">
                <h1>Edit shipping rule</h1>
            </div>

            {
                Object.keys(shippingRules).length > 0 && <FormShippingRule
                    loading={loading}
                    error={error}
                    shippingRules={shippingRules}
                    platforms={platforms}
                    onUpdateShippingRule={upShippingRule}
                />
            }

            <div className="History">
                <ShippingHistory shippingId={shipping_rule_id}/>
            </div>
        </div>
    )
}

export default EditShippingRule
